import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { serverurl } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  constructor(
    private http: HttpClient
  ) { }


  saveReport(roundId: string, buttonName: string) {
    return new Promise((resolve) => {
      resolve(true);
      // this.http.post(serverurl + '/data/report', { roundId, buttonName }).subscribe({
      //   next: (data: any) => {
      //     resolve(true);
      //   },
      //   error: (err) => {
      //     resolve(false);
      //   }
      // });
    });
  }
}
